import { render, staticRenderFns } from "./ModalFilesSupplier.vue?vue&type=template&id=b7f1be96"
import script from "./ModalFilesSupplier.vue?vue&type=script&lang=js"
export * from "./ModalFilesSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports